// extracted by mini-css-extract-plugin
module.exports = {"days":"PackageList_style_days__3gtnS"};